import { createStoreContext } from "reusable/mobx-store-utils/storeUtils"
import { DIRECTIVE_NAME } from "./GapFile"
import ModalState from "reusable/mobx-helpers/ModalState"
import { apiClient } from "api/trpc/trpc-client"
import { makeAutoObservable } from "mobx"
import MarkdownStore from "reusable/markdown/MarkdownStore"
import { decodeFile } from "reusable/utils/file-operations"

interface GapFilePluginStoreProps {
   insertDirective: (directive: any) => void
   orgId: string
   markdownStore: MarkdownStore
}

export default class GapFilePluginStore {
   sp
   modalState = new ModalState({
      onClose: async () => {
         this.file = null
         this.uploadedFileName = null
      }
   })
   file: File | null = null
   private uploadedFileName: string | null = null

   constructor(sp: GapFilePluginStoreProps) {
      makeAutoObservable(this)
      this.sp = sp
   }

   getPresignedUrl = async (file: File) => {
      this.uploadedFileName = file.name
      const { url } = await apiClient.markdown.getFileUploadUrl.query({ fileName: this.uploadedFileName, entityId: this.sp.markdownStore.sp.id })
      return url
   }

   onFilesValidated = async (files: File[]) => {
      if (files.length === 0 || !this.uploadedFileName) return
      const { file } = decodeFile(this.uploadedFileName) // Remove ulid from filename(for display purposes)
      const name = file.name.split('.').slice(0, -1).join('.') // Remove extension

      this.sp.insertDirective({
         name: DIRECTIVE_NAME,
         type: 'textDirective',
         attributes: {
            name,
            rawFileName: this.uploadedFileName
         },
      })

      this.uploadedFileName = name
      this.file = files[0]

      this.uploadedFileName = null
      this.modalState.close()
   }
}

export const { Provider: GapFilePluginStoreProvider, useProvidedStore: useGapFilePluginStore } = createStoreContext(GapFilePluginStore)
